import React, { Fragment, useEffect, useState } from 'react'
import { media } from 'app/assets/styles'
import BlazonSticker from 'app/common/blazon/sticker/BlazonSticker'
import { Flip } from 'app/common/flip'
import { H6, Text } from 'app/common/typography'
import { getQrCode } from 'app/common/utils'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import styled, { css } from 'styled-components'
import { formatKingdomCode } from 'shared/utils'

const KingdomCard = () => {
    const { kingdomAuthCode, blazonProfileImageUrl } = useSelector(
        (state: RootState) => state.kingdomCardPageState
    )
    const [qrCode, setQrCode] = useState('')
    const [recto, setRecto] = useState(true)

    useEffect(() => {
        setQrCodeState(kingdomAuthCode)
    }, [])

    const setQrCodeState = async (code: string) => {
        const qrCode = await getQrCode(code)
        setQrCode(qrCode)
    }

    const flip = () => {
        setRecto(!recto)
    }

    const front = (
        <Front hasBlazon={!!blazonProfileImageUrl}>
            {!!blazonProfileImageUrl && (
                <BlazonContainer>
                    <BlazonSticker imageUrl={blazonProfileImageUrl} />
                </BlazonContainer>
            )}
            <FrontBody>
                <StyledH6>
                    <FormattedMessage id="kingdom.card.title" />
                </StyledH6>
                <Image src={qrCode} front />
                <QRText>{formatKingdomCode(kingdomAuthCode)}</QRText>
            </FrontBody>
        </Front>
    )

    return (
        <Section>
            <Flip
                recto={recto}
                front={front}
                back={front}
                minHeight={200}
                className="card"
            />
        </Section>
    )
}

const Section = styled.section`
    width: 100%;
    max-width: 330px;
    border-radius: 10px;
    margin-bottom: 20px;
    min-height: 50px;
    ${media.medium`
        width: 45%;
        margin-right: 2%;
    `};
`

const Front = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: ${({ hasBlazon }) => (hasBlazon ? 'flex-end' : 'center')};
    width: 100%;
    padding: 24px 40px;
    box-sizing: border-box;
`

const BlazonContainer = styled.div`
    top: 0;
    left: 0;
    position: absolute;
    display: inline-block;
    width: 100px;
    margin-left: 12.5%;
`

const FrontBody = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
`

const QRText = styled(Text)`
    margin-top: -14px; /* too much space around the QR-Code */
`

const image = css`
    height: auto;
    margin: auto;
`

const StyledH6 = styled(H6)`
    text-align: center;
    font-size: 14px;
    line-height: 22px;
    ${media.medium`
        font-size: 16px;
        line-height: 20px;
    `};
`

const Image = styled.img`
    ${image};
    width: 100%;
`

export { KingdomCard }
